import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { AppPreferences } from "../../../shared/local/app-preferences.local";
import { ResponseCheckPollingDto } from "../../../shared/nestjs/gd-only/dto/poling.dto";
import { NestApiProvider } from "../../../shared/nestjs/nest-api";
import { PollingSf6Provider } from "../../../shared/nestjs/polling/polling-sf6";

@Injectable()
export class PollingBloc {

    constructor(
        private appPreferences: AppPreferences,
        private nestApiProvider: NestApiProvider,
        private pollingSf6Provider: PollingSf6Provider,
    ) {

    }

    private checkPollingList(): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    return this.pollingSf6Provider.checkPollingList().pipe(
                        map(params => params.data)
                    )
                } else {
                    return null
                }
            })
    }

    async getPollingFromServer(): Promise<any> {
        try {
            const auth = await this.appPreferences.getAuth();
            if (auth.menu["periodic-survey"]) {
                const poll = await this.checkPollingList().toPromise();
                await this.appPreferences.setPolling(poll);
            } else {
                await this.appPreferences.setPolling(null);
            }
        } catch (error) {
            await this.appPreferences.setPolling(null);
        }
        return true;
    }

    async checkPollingFromServer(): Promise<any> {
        try {
            const auth = await this.appPreferences.getAuth();
            if (auth.menu["periodic-survey"]) {
                const arrayPoll = await this.getPollingFromStorage();
                if (!arrayPoll || arrayPoll.length == 0) {
                    await this.getPollingFromServer();
                }
            }
        } catch (error) { }
        return true;
    }

    async getPollingFromStorage(): Promise<ResponseCheckPollingDto[]> {
        return await this.appPreferences.getPolling();
    }

    async setPollingToStorage(data: any): Promise<boolean> {
        return await this.appPreferences.setPolling(data);
    }

}


// WEBPACK FOOTER //
// ./src/bloc/feature/polling/polling.bloc.ts